import React from "react";
import { cn } from "@/utils/utils";

interface Props {
  hex: string;
  selected?: boolean;
  size?: "trigger" | "option";
  onClick?: () => void;
}

const ColorSwatch: React.FC<Props> = ({
  hex,
  selected,
  size = "option",
  onClick
}) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={hex}
    className={cn(
      "rounded-lg transition-all duration-150",
      size === "trigger" ? "w-7 h-7" : "w-9 h-9",
      selected
        ? "ring-2 ring-offset-2 ring-offset-surface-droplist-popover ring-border-cta"
        : "hover:scale-105"
    )}
    style={{
      background: `linear-gradient(135deg, ${hex} 0%, ${hex}CC 100%)`
    }}
  />
);

export default ColorSwatch;
